import React from 'react';
import { FaCar, FaBullseye, FaEye } from 'react-icons/fa';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-image reveal">
          <div className="placeholder-content">
            <FaCar className="icon" />
            <div style={{ fontSize: '18px', fontWeight: 600, color: 'rgba(255,255,255,0.3)' }}>AUTO EXPERTS FZE</div>
            <div style={{ fontSize: '13px', opacity: 0.3, marginTop: '8px' }}>Dubai · Jebel Ali Free Zone</div>
          </div>
          <div className="about-badge">
            <span className="num">10+</span>
            Years of Excellence
          </div>
        </div>

        <div className="about-content reveal reveal-delay-1">
          <div className="section-header" style={{ textAlign: 'left', margin: '0 0 24px 0', maxWidth: '100%' }}>
            <span className="label">About Us</span>
            <h2 style={{ fontSize: 'clamp(28px, 3.5vw, 40px)' }}>Global Leader in <span className="highlight">Genuine</span> Automotive Parts</h2>
          </div>

          <p>
            AUTO EXPERTS FZE is a Dubai-based B2B company specializing in the wholesale supply
            and worldwide export of Genuine American Automotive Spare Parts. Operating from the
            strategic Jebel Ali Free Zone, we serve a global network of importers, dealers, and
            fleet companies with uncompromising quality and reliability.
          </p>
          <p>
            Our commitment to <strong>genuine parts</strong>, competitive wholesale pricing, and
            fast response times has made us a trusted partner for businesses across 40+ countries.
          </p>

          <div className="about-grid">
            <div className="about-grid-item">
              <FaBullseye className="icon" />
              <h4>Mission</h4>
              <p>To deliver genuine American auto parts with speed, integrity, and global reach.</p>
            </div>
            <div className="about-grid-item">
              <FaEye className="icon" />
              <h4>Vision</h4>
              <p>To be the world's most trusted wholesale supplier of genuine automotive parts.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;